import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoaderProvider } from "./context/LoaderContext";
import Loader from "./components/Loader";

// Modern NIN Verification Pages
import Login from "./pages/Login";
import NINVerification from "./pages/NINVerification";
import UserManagement from "./pages/Admin/UserManagement";

function App() {
  return (
    <LoaderProvider>
      <div className="App">
        <Loader />

        {/* Global Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        {/* Application Routes */}
        <Routes>
          {/* Main NIN Verification Flow */}
          <Route path="/dashboard" element={<NINVerification />} />
          <Route path="/verify-nin" element={<NINVerification />} />
          <Route path="/" element={<Login />} />

          {/* Admin User Management */}
          <Route path="/admin/users" element={<UserManagement />} />
          <Route
            path="/admin/UsersTable"
            element={<Navigate to="/admin/users" replace />}
          />
          <Route
            path="/AdminLogin"
            element={<Navigate to="/login" replace />}
          />
          <Route
            path="/AdminDashbord"
            element={<Navigate to="/admin/users" replace />}
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </LoaderProvider>
  );
}

export default App;
